import { render, staticRenderFns } from "./DialogNeed.vue?vue&type=template&id=64cedbce&scoped=true&"
import script from "./DialogNeed.vue?vue&type=script&lang=js&"
export * from "./DialogNeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cedbce",
  null
  
)

export default component.exports